import { includes, intersection } from 'lodash';

import { RoleVariantEnum } from 'common/graphql/types';

const hasPermission = (auth, requiredPermissions = []): boolean => {
    const userPermissions: string[] = auth.activeUser.permissions;
    const hasPermission = !requiredPermissions.length || intersection(requiredPermissions, userPermissions).length;

    return !!hasPermission;
};

export const checkPermissions = ({ permissions = [], auth }): boolean => {
    return auth?.activeUser && hasPermission(auth, permissions);
};
const hasRoles = (auth, requiredRole = [], permissions = []): boolean => {
    if (
        (auth.activeUser?.roleVClaim && auth.activeUser?.roleVClaim?.sk) ||
        (auth.activeUser?.roleBClaim && auth.activeUser?.roleBClaim?.sk)
    ) {
        const roleId =
            auth.activeUser?.roleVClaim?.sk ||
            (auth.activeUser?.roleBClaim?.sk && auth.activeUser?.role === RoleVariantEnum.SystemAdministrator
                ? auth.activeUser?.role // since base role id of sysadmin and subadmin are same, differentiating with role attribute
                : auth.activeUser?.roleBClaim?.sk);
        //Checked role and Permission
        if (requiredRole?.length && permissions?.length) {
            const isCheckUserPermissions = hasPermission(auth, permissions);

            return includes(requiredRole, roleId) && isCheckUserPermissions;
        } else {
            return includes(requiredRole, roleId);
        }
    } else {
        return hasPermission(auth, permissions);
    }
};

export const checkRoles = ({ roles = [], auth = null, permissions = [] }): boolean => {
    return auth?.activeUser && hasRoles(auth, roles, permissions);
};

export const isUserLoggedIn = (authContext): boolean =>
    authContext != null && authContext.activeUser != null && authContext.switchingUser !== null;
